"use client"
import dynamic from "next/dynamic";
const Component = dynamic(() => import("./_component"));

const Index = ({ props }) => {

	return (
		<div className="mt-[70px] lg:mt-[200px] lg:mb-[75px]">
			{/* تنها h1 صفحه؛ نتیجه‌ی پرداخت عنوان دیداری ثابتی ندارد */}
			<h1 className="sr-only">نتیجه پرداخت</h1>

			<Component {...{ ...props }} />
		</div>
	)
};
export default Index;
